module.exports = __webpack_public_path__ + "static/media/twoArrows.61496382.svg";